// ------------------------------------
// Completa endereço
// ------------------------------------
(function () {
  'use strict';

  // Variáveis
  const urlApi = urlBase + 'core/acoes/shipping/completa_endereco.php';
  const $cep = $('#cart-zipcode');
  const $btn = $('#btn-cart-zipcode');
  const btnText = $btn.html();
  const $inputWrapper = $('.cart-ship-res');
  let address = {};

  // Busca o cep ao clicar no botão
  $btn.on('click', handleAddress);
  $cep.on('input', handleAddress);
  function handleAddress() {
    const cepLength = $cep.val().replace(/\D/g, '').length;
    if (cepLength >= 8) {
      getAddress();
    }
  }

  // Verifica se tem gravado na sessão
  if ($cep.length) {
    if (sessionStorage.getItem('cart_address')) {
      try {
        const addressSession = JSON.parse(sessionStorage.getItem('cart_address'));
        if (addressSession?.cep && addressSession?.cidade && addressSession?.uf) {
          address = addressSession;
          $cep.val(address?.cep_view);
          populateAddress();
          if ($('body').hasClass('pag-cart')) {
            setTimeout(() => {
              $cep.trigger('get-shipping');
            }, 100);
          }
        }
      } catch (error) {}
    }
  }

  // Obtém o endereço completo
  function getAddress() {
    processingAddress();
    // Realiza a requisição dos dados
    $.getJSON(`${urlApi}?cep=${$cep.val()}&slug=${baseStore}`, function (result) {
      console.log(result);
      finishedAddress();
      if (result.cidade) {
        address = result;
        address.cep_view = $cep.val();
        sessionStorage.setItem('cart_address', JSON.stringify(address));
        populateAddress();
        $cep.trigger('get-shipping');
      } else {
        showAlert('Atenção', 'Endereço não encontrado!<br> Verifique o CEP informado.', 'warning');
      }
    }).fail(errorAddress);
  }

  // Popula os campos do endereço
  function populateAddress() {
    $('#cs_address').val(address.logradouro);
    $('#cs_neighborhood').val(address.bairro);
    $('#cs_city').val(address.cidade);
    $('#cs_uf').val(address.uf);
    $('.cart-ship-res-tit b').text(`${address.cidade} / ${address.uf}`);
  }

  // Ações executadas enquanto a requisição é processada
  function processingAddress() {
    $inputWrapper.slideUp();
    $btn.prop('disabled', true).addClass('btn-loader').text('');
    //$cep.prop('readonly', true);
  }

  // Ações executadas quanto a requisição é finalizada
  function finishedAddress() {
    $btn.prop('disabled', false).removeClass('btn-loader').html(btnText);
    //$cep.prop('readonly', false);
  }

  // Erro na requisição do endereço
  function errorAddress(resp) {
    console.log(resp);
    finishedAddress();
    showAlert('Atenção', 'Endereço não encontrado!<br> Verifique o CEP informado.', 'warning');
  }
})();

// ------------------------------------
// Formas de envio
// ------------------------------------
(function () {
  'use strict';

  // Variáveis
  const $shippingWaysWrp = $('.cart-ship-res');
  const $shippingWays = $('.cart-ship-res-list');
  const $zipcode = $('#cart-zipcode');
  const urlApi = urlBase + 'core/acoes/shipping/formas_entrega.php';
  const $loader = $('.cart-ship-loader');
  let zipcode;
  let shipping_ways;
  let reqAjax = null;

  // Ao selecionar um forma de envio
  $shippingWays.on('change', 'input', handleChangeShippingWays);
  function handleChangeShippingWays() {
    const $shippingWay = $shippingWays.find('input:checked');
    const shippingWay = $shippingWay.val();
    const title = $shippingWay.data('desc');
    const price = $shippingWay.data('price');
    $shippingWays.data('value', shippingWay);
    if ($('.cart-resume').length > 0) {
      $('.v-cart-frete-desc').text(`Entrega (${title})`);
    }
    calcCart();
  }

  // Ao alterar o cep de destino
  $zipcode.on('get-shipping', handleShippingWays);

  /* if ($zipcode.val() != '') {
    handleShippingWays();
  } */
  function handleShippingWays() {
    if ($shippingWays.length > 0) {
      zipcode = $zipcode.val();
      if (zipcode != '' && zipcode.length >= 8) {
        getShippingWays();
      }
    }
  }

  // Obtém as formas de entrega
  function getShippingWays() {
    processingSW();
    const dataShip = $zipcode.data('infos') || {};
    dataShip['store_token'] = publicToken;
    dataShip['store_id'] = baseLanding;
    dataShip['zipcode'] = zipcode;
    dataShip['address'] = $('#cs_address').val();
    dataShip['neighborhood'] = $('#cs_neighborhood').val();
    dataShip['city'] = $('#cs_city').val();
    dataShip['uf'] = $('#cs_uf').val();
    // Cálculo da página do produto
    if ($('body').hasClass('pag-produto')) {
      dataShip['mode'] = 'product';
      dataShip['length'] = curVariant?.length || 0;
      dataShip['height'] = curVariant?.height || 0;
      dataShip['width'] = curVariant?.width || 0;
      dataShip['weight'] = curVariant?.weight || 0;
      dataShip['insurance_value'] = curVariant?.sale_price || 0;
      dataShip['quantity'] = $('#quantity').val() || 1;
      dataShip['sku'] = curVariant?.sku;
      dataShip['product_id'] = curVariant?.product_id;
    }
    // Realiza a requisição dos dados
    $.getJSON(urlApi, dataShip, function (result) {
      if (result.status == 'success') {
        console.log(result);
        shipping_ways = result.shipping_ways;
        populateShippingWays();
      } else {
        errorSW(result);
      }
    }).fail('errorSW');
  }

  // Popula as formas de envio
  function populateShippingWays() {
    $shippingWays.find('.form-group').html('');
    shipping_ways.forEach((way, index) => {
      let checked = '';
      if (($shippingWays.data('value') != '' && $shippingWays.data('value') === way.shipping_way) || index === 0) {
        checked = 'checked';
      } else if (index === 0) {
        checked = 'checked';
      }
      const priceView = Number(way.price) > 0 ? 'R$ ' + formatMoneyBR(Number(way.price)) : 'Grátis';
      const textPrazo = way.text ? ' (' + way.text + ')' : '';
      $shippingWays.find('.form-group').append(`
      <div class="form-check">
        <input type="radio" name="shipping_way" id="co_shipping_way_${way.shipping_way}" value="${way.shipping_way}" data-desc="${way.title}" data-price="${way.price}" ${checked}>
        <label for="co_shipping_way_${way.shipping_way}"><div class="shipping-way-item"><span>${way.title}${textPrazo}</span><b>${priceView}</b></div></label>
      </div>`);
    });
    $shippingWaysWrp.slideDown();
    finishedSW();
    $('body').trigger('shipping-ways-show');
  }

  // Ações executadas enquanto a requisição é processada
  function processingSW() {
    $shippingWaysWrp.slideUp();
    $loader.show();
  }

  // Ações executadas quanto a requisição é finalizada
  function finishedSW() {
    $loader.hide();
    handleChangeShippingWays();
  }

  // Erro na requisição
  function errorSW(resp) {
    console.log(resp);
    $loader.hide();
    $shippingWaysWrp.slideUp();
    finishedSW();
  }
})();

// ------------------------------------
// Carrinho
// ------------------------------------

// Variáveis
let cartInfos = $infosBase.data('cart-infos');
const cartMaxQty = $('#infos-base').data('cart-maxqty');
let cartLoading = false;
if (cartInfos?.num_rows > 0) {
  populateCart();
}

// Obtém carrinho
function getCart(cb = null) {
  if (!cartLoading) {
    cartLoading = true;
    showLoader();
    const urlApi = urlBase + 'core/acoes/themes/boosterstore/carrinho/carrinho.php';
    const data = {
      acao: 'view',
      store_id: baseLanding,
      store_token: publicToken,
    };
    $.getJSON(`${urlApi}`, data, function (result) {
      console.log(result);
      cartLoading = false;
      hideLoader();
      if (result.status === 'success') {
        cartInfos = result.cart;
        populateCart();
        populateCartTop();
        calcCart();
        if (cb !== null) {
          cb(cartInfos);
        }
      } else {
        console.log('Não foi possível obter o carrinho.');
        cartInfos = false;
      }
    }).fail(function (resp) {
      console.log('Não foi possível obter o carrinho.');
      console.log(resp);
      cartInfos = false;
      cartLoading = false;
      hideLoader();
    });
  }
}

// Popula o carrinho
function populateCart() {
  // Variáveis
  const cartTotal = cartInfos.num_rows;
  const cartItens = cartInfos.result.items;
  const $productsList = $('#cart-products-list');
  let numOutStock = 0;
  if ($productsList.length > 0 && cartTotal > 0) {
    $productsList.html('');
    cartItens.forEach((itemCart) => {
      const subtotal = itemCart['subtotal'];
      const $subtitle = itemCart['slug'] != 'u' ? `<div class="cart-prod-text">${itemCart['variant_title']}</div>` : '';
      let progDiscount = 0;
      if (typeof itemCart['progressive_discount'] !== 'undefined' && itemCart['progressive_discount'] > 0) {
        progDiscount = Number(itemCart['progressive_discount']);
      }
      let progDiscountView =
        typeof itemCart['progressive_discount'] === 'number' ? progDiscount.toString().replace('.', ',') + '%' : '0%';
      const $discBadge = progDiscount > 0 ? `<span class="badge">${progDiscountView} Off</span>` : '';
      const $discBadge2 = $discBadge != '' > 0 ? '<br>' + $discBadge : '';
      let $customInfos = '';
      const $priceOldDisc =
        progDiscount > 0 ? `<span class="old-price">R$ ${formatMoneyBR(itemCart['old_price'])}</span>` : '';
      const $customAmount =
        itemCart['customizations_amount'] > 0
          ? `<small>(+ R$ ${formatMoneyBR(itemCart['customizations_amount'])})</small>`
          : '';
      const $customAmount2 = '<br>' + $customAmount;
      if (itemCart['has_customizations'] == 1 && itemCart['customizations_infos']) {
        $customInfos += `<div class="cart-prod-custom"><b>Personalização</b><ul>`;
        Object.keys(itemCart['customizations_infos']).forEach((csi) => {
          $customInfos += `<li>${itemCart['customizations_infos'][csi]}</li>`;
        });
        $customInfos += `</ul></div>`;
      }
      let outStockClass = '';
      let maxQty;
      if (itemCart.automatic_stock == '1') {
        if (itemCart.qty_stock > 0) {
          maxQty = itemCart.qty_stock > cartMaxQty ? cartMaxQty : itemCart.qty_stock;
        } else {
          maxQty = 1;
          numOutStock++;
          outStockClass = 'out-stock';
        }
      } else {
        maxQty = cartMaxQty;
      }
      const $itemCart = `<tr class="cart-table-item ${outStockClass}" data-cart-item="${
        itemCart['cart_product_id']
      }" data-variant-sku="${itemCart['variant_sku']}">
        <td>
          <a class="cart-prod">
            <div class="cart-prod-img">
              <figure class="img img-rounded img-border">
                <img src="${itemCart['thumb']}" alt="${itemCart['product_title']}">
              </figure>
            </div>
            <div class="cart-prod-infos">
              <div class="cart-prod-title">${itemCart['product_title']}</div>
              ${$subtitle}
              <div class="cart-prod-price v-item-subtotal">R$ ${formatMoneyBR(
                subtotal,
              )} ${$customAmount} ${$discBadge}</div>
              ${$customInfos}
            </div>
          </a>
        </td>
        <td class="center d-none-sm d-none-xs">
          ${$priceOldDisc}
          R$ ${formatMoneyBR(itemCart['sale_price'])}
          ${$discBadge2}
        </td>
        <td class="center cart-spinner-wrp text-left-sm text-left-xs mb-sm-0 mb-xs-0">
          <div class="form-group">
            <div class="number-spinner">
              <button class="ns-btn ns-sub"></button>
              <input type="text" inputmode="numeric" name="quantity" class="ns-input number" value="${
                itemCart['product_qtdy']
              }" min="1" max="${maxQty}">
              <button class="ns-btn ns-add"></button>
            </div>
          </div>
        </td>
        <td class="center d-none-sm d-none-xs">
          <b class="v-item-subtotal">R$ ${formatMoneyBR(subtotal)}</b>
          ${$customAmount2}
        </td>
        <td class="right btn-rem-cart-wrp">
          <button class="btn btn-sm btn-rem-cart" title="Remover"><svg viewBox="0 0 32 32"><path fill="currentColor" d="M 7.21875 5.78125 L 5.78125 7.21875 L 14.5625 16 L 5.78125 24.78125 L 7.21875 26.21875 L 16 17.4375 L 24.78125 26.21875 L 26.21875 24.78125 L 17.4375 16 L 26.21875 7.21875 L 24.78125 5.78125 L 16 14.5625 Z"></path></svg></button>
        </td>
      </tr>`;
      $productsList.append($itemCart);
    });
    if (numOutStock > 0) {
      disableBtnCart();
      setTimeout(() => {
        showAlert(
          'Atenção',
          'Alguns itens do seu carrinho estão<br> <b>sem estoque</b>. Remova-os para continuar com a compra.',
          'warning',
        );
      }, 1000);
    } else {
      enableBtnCart();
    }
    initSpinners();
    initInputsMask();
    calcCart();
  }
  populateCartSide();
}

// Popula o carrinho lateral
function populateCartSide() {
  const $cartSide = $('#cart-side');
  if ($cartSide.length) {
    // Variáveis
    const cartTotal = cartInfos.num_rows;
    const cartItens = cartInfos.result.items;
    const $productsList = $('.cart-side-list');
    const $cartEmpty = $('.cart-side-empty-wrp');
    const $cartContent = $('.cart-side-list-wrp, #cart-side .page-side-footer');
    let numOutStock = 0;
    if ($productsList.length > 0 && cartTotal > 0) {
      $productsList.html('');
      cartItens.forEach((itemCart) => {
        const subtotal = itemCart['subtotal'];
        const $subtitle =
          itemCart['slug'] != 'u'
            ? `<div class="cart-side-i-txt cart-side-i-variant">${itemCart['variant_title']}</div>`
            : '';
        let progDiscount = 0;
        if (typeof itemCart['progressive_discount'] !== 'undefined' && itemCart['progressive_discount'] > 0) {
          progDiscount = Number(itemCart['progressive_discount']);
        }
        let progDiscountView =
          typeof itemCart['progressive_discount'] === 'number' ? progDiscount.toString().replace('.', ',') + '%' : '0%';
        const $discBadge = progDiscount > 0 ? `<span class="badge">${progDiscountView} Off</span>` : '';
        let $customInfos = '';
        const $priceOldDisc =
          progDiscount > 0 ? `<span class="old-price">R$ ${formatMoneyBR(itemCart['old_price'])}</span> ` : '';
        const $customAmount =
          itemCart['customizations_amount'] > 0
            ? `<small>(+ R$ ${formatMoneyBR(itemCart['customizations_amount'])})</small>`
            : '';
        const $customAmount2 = '<br>' + $customAmount;
        if (itemCart['has_customizations'] == 1 && itemCart['customizations_infos']) {
          $customInfos += `<div class="cart-prod-custom"><b>Personalização</b><ul>`;
          Object.keys(itemCart['customizations_infos']).forEach((csi) => {
            $customInfos += `<li>${itemCart['customizations_infos'][csi]}</li>`;
          });
          $customInfos += `</ul></div>`;
        }
        let outStockClass = '';
        let maxQty;
        if (itemCart.automatic_stock == '1') {
          if (itemCart.qty_stock > 0) {
            maxQty = itemCart.qty_stock > cartMaxQty ? cartMaxQty : itemCart.qty_stock;
          } else {
            maxQty = 1;
            numOutStock++;
            outStockClass = 'out-stock';
          }
        } else {
          maxQty = cartMaxQty;
        }
        const $itemCart = `
        <li class="cart-side-i ${outStockClass}" data-cart-item="${itemCart['cart_product_id']}" data-variant-sku="${
          itemCart['variant_sku']
        }">
          <div class="img img-rounded img-border cart-side-i-img">
            <img src="${itemCart['thumb']}" alt="${itemCart['product_title']}" width="85px" height="85px">
          </div>
          <div class="cart-side-i-infos">
            <div class="cart-side-i-tit">${itemCart['product_title']}</div>
            ${$subtitle}
            <div class="cart-side-i-txt cart-side-i-price">${$priceOldDisc} <b class="cart-side-i-sale-price">R$ ${formatMoneyBR(
          itemCart['sale_price'],
        )}</b> ${$discBadge}</div>
            ${$customInfos}
            <div class="cart-side-i-act">
              <div class="cart-side-i-qty">
                <div class="form-group">
                  <div class="number-spinner">
                    <button class="ns-btn ns-sub"></button>
                    <input type="text" inputmode="numeric" name="quantity" class="ns-input number" value="${
                      itemCart['product_qtdy']
                    }" min="1" max="${maxQty}">
                    <button class="ns-btn ns-add"></button>
                  </div>
                </div>
              </div>
              <div class="cart-side-i-total">R$ ${formatMoneyBR(subtotal)}${$customAmount2}</div>
            </div>
            <button class="btn btn-sm btn-rem-cart" title="Remover"><svg viewBox="0 0 32 32"><path fill="currentColor" d="M 7.21875 5.78125 L 5.78125 7.21875 L 14.5625 16 L 5.78125 24.78125 L 7.21875 26.21875 L 16 17.4375 L 24.78125 26.21875 L 26.21875 24.78125 L 17.4375 16 L 26.21875 7.21875 L 24.78125 5.78125 L 16 14.5625 Z"></path></svg></button>
          </div>
        </li> `;
        $productsList.append($itemCart);
      });
      if (numOutStock > 0) {
        if (!$cartSide.hasClass('active')) {
          sideOpen('cart-side');
        }
        disableBtnCart();
        setTimeout(() => {
          showAlert(
            'Atenção',
            'Alguns itens do seu carrinho estão<br> <b>sem estoque</b>. Remova-os para continuar com a compra.',
            'warning',
          );
        }, 1000);
      } else {
        enableBtnCart();
      }
      $cartContent.removeClass('d-none');
      $('#cart-side .page-side-btns .btn')
        .first()
        .attr('href', urlBase + cartInfos.cart_url);
      $cartEmpty.addClass('d-none');
      initSpinners();
      calcCart();
    } else {
      $cartContent.addClass('d-none');
      $cartEmpty.removeClass('d-none');
    }
  }
}

// Popula carrinho topo
function populateCartTop() {
  // Variáveis
  const cartTotal = cartInfos.num_rows;
  const cartItens = cartInfos.result.items;
  const $cartEmpty = $('.dropdown-cart-empty');
  const $cartContent = $('.dropdown-cart-content');
  const $productsList = $('.dropdown-cart-items');
  const $badgeCart = $('.header-cart-btn .badge');
  $productsList.html('');
  if (cartTotal > 0) {
    cartItens.forEach((itemCart) => {
      const $itemCart = `
      <div class="dropdown-cart-item" data-cart-item="${itemCart['cart_product_id']}" data-variant-sku="${
        itemCart['variant_sku']
      }">
        <div class="dropdown-cart-item-img">
          <img src="${itemCart['thumb']}" alt="${itemCart['product_title']}">
        </div>
        <div class="dropdown-cart-item-infos">
          <div class="dropdown-cart-item-title">${itemCart['product_title']}</div>
          <div class="dropdown-cart-item-price">R$ ${formatMoneyBR(itemCart['subtotal'])}</div>
        </div>
      </div>`;
      $productsList.append($itemCart);
    });
    $badgeCart.removeClass('d-none');
    $cartContent.removeClass('d-none');
    $cartEmpty.addClass('d-none');
  } else {
    $badgeCart.addClass('d-none');
    $cartContent.addClass('d-none');
    $cartEmpty.removeClass('d-none');
  }
}

// Calcula o carrinho
function calcCart() {
  const cartTotal = cartInfos.num_rows;
  const cartTotalLbl = cartTotal > 1 ? ' itens' : ' item';
  const cartSubtotal = cartInfos.cart_subtotal;
  const cartItens = cartInfos.result.items;
  const cartDiscount = cartInfos?.cart_progressive_discount || 0;
  let cartCustomAmount = 0;
  let cartAmount = 0;
  const cartShip =
    $('input[name="shipping_way"]:checked').length > 0
      ? Number($('input[name="shipping_way"]:checked').data('price'))
      : 0;
  if (cartInfos.num_rows > 0) {
    cartItens.forEach((itemCart, itemCartIndex) => {
      cartCustomAmount += itemCart['customizations_amount'];
    });
  }
  cartAmount = cartSubtotal + cartShip + cartCustomAmount - cartDiscount;
  $('.v-cart-count').text(cartTotal);
  $('.v-cart-count-lbl').text('(' + cartTotal + cartTotalLbl + ')');
  $('.v-cart-subtotal').text('R$ ' + formatMoneyBR(cartSubtotal));
  if (cartCustomAmount > 0) {
    $('.v-cart-custom').text('+ R$ ' + formatMoneyBR(cartCustomAmount));
    $('.cart-resume-customs-wrp').show();
  } else {
    $('.v-cart-custom').text('+ R$ 0,00');
    $('.cart-resume-customs-wrp').hide();
  }
  if (cartDiscount > 0) {
    $('.v-cart-discount').text('- R$ ' + formatMoneyBR(cartDiscount));
    $('.cart-resume-discount-wrp').show();
  } else {
    $('.v-cart-discount').text('- R$ 0,00');
    $('.cart-resume-discount-wrp').hide();
  }
  $('.v-cart-frete').text(cartShip ? 'R$ ' + formatMoneyBR(cartShip) : '-');
  $('.v-cart-total').text('R$ ' + formatMoneyBR(cartAmount));
  if (cartInfos.cart_url) {
    $('.cart-btn-cta').attr('href', cartInfos.cart_url);
  }
  verifyStockCart();
  $('body').trigger('cart-loaded');
}

// Verificação de estoque
function verifyStockCart() {
  const cartItens = cartInfos.result.items;
  if (cartItens && cartItens.length > 0) {
    cartItens.forEach((itemCart) => {
      if (itemCart.automatic_stock == '1' && Number(itemCart.qty_stock) < Number(itemCart.product_qtdy)) {
        // Estoque zerado (Remove o produto)
        if (Number(itemCart.qty_stock) === 0) {
          console.log('Produto sem estoque: ' + itemCart.product_title);
          /* updateCart({
            acao: 'remove',
            store_id: baseLanding,
            product: itemCart.cart_product_id,
          }); */
        }
        // Estoque menor que o pedido (Atualiza a quantidade)
        else {
          console.log('Produto com estoque menor que o pedido: ' + itemCart.product_title);
          updateCart({
            acao: 'update',
            store_id: baseLanding,
            product: itemCart.cart_product_id,
            variant_sku: itemCart.variant_sku,
            quantity: itemCart.qty_stock,
          });
        }
      }
    });
  }
}

// Ativa botão de finalização
function enableBtnCart() {
  $('.cart-btn-cta').removeClass('disabled').prop('disabled', false);
}

// Desativa botão de finalização
function disableBtnCart() {
  $('.cart-btn-cta').addClass('disabled').prop('disabled', true);
}

// Remove um item do carrinho
(function () {
  'use strict';
  $('body').on('click', '.btn-rem-cart', function (ev) {
    ev.preventDefault();
    const $cartItem = $(this).closest('[data-cart-item]');
    if ($cartItem.length > 0) {
      const cartItem = $cartItem.data('cart-item');
      updateCart({
        acao: 'remove',
        store_id: baseLanding,
        product: cartItem,
      });
    }
  });
})();

// Atualiza a quantidade do carrinho
(function () {
  'use strict';
  $('.pag-cart, #cart-side').on('change', '.ns-input', function (ev) {
    const quantity = $(this).val();
    const $cartItem = $(this).closest('[data-cart-item]');
    const cartItem = $cartItem.data('cart-item');
    const variantSku = $cartItem.data('variant-sku');
    updateCart({
      acao: 'update',
      product: cartItem,
      variant_sku: variantSku,
      store_id: baseLanding,
      quantity: quantity,
    });
  });
})();

// Atualiza o carrinho
function updateCart(data) {
  const urlApi = urlBase + 'core/acoes/themes/boosterstore/carrinho/carrinho.php';
  showLoader();
  data.store_token = publicToken;
  data.cart_token = cartInfos.cart_token;
  $.getJSON(`${urlApi}`, data, function (result) {
    hideLoader();
    if (result.status_action === 'success') {
      if (result.cart.num_rows > 0 || $('#cart-side').length > 0) {
        if (result.cart.num_rows == 0 && $('.pag-cart').length) {
          location.reload();
          return false;
        }
        cartInfos = result.cart;
        populateCart();
        populateCartTop();
        calcCart();
        if ($('#cart-zipcode').val()) {
          $('#cart-zipcode').trigger('get-shipping');
        }
      } else {
        location.reload();
      }
    } else if (result.status_action === 'error_stock') {
      populateCart();
      populateCartTop();
      showAlert('Produto sem estoque', 'Infelizmente não temos mais estoque para o item escolhido.', 'danger');
    } else {
      showAlert('Erro', 'Não foi possível realizar esta operação.', 'danger');
    }
  }).fail(function (resp) {
    console.log(resp);
    hideLoader();
    showAlert('Erro', 'Não foi possível realizar esta operação.', 'danger');
  });
}
